import React from "react";

const IndustrySVG = ({ height, width, fill = "none" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="4" fill="#F5F7FF" />
      <g clipPath="url(#clip0_1240_6896)">
        <path
          d="M14.5536 7.45422C14.3799 7.37499 14.1912 7.33398 14.0003 7.33398C13.8094 7.33398 13.6207 7.37499 13.447 7.45422L7.73363 10.0542C7.61533 10.1064 7.51475 10.1918 7.44414 10.3001C7.37353 10.4084 7.33594 10.5349 7.33594 10.6642C7.33594 10.7935 7.37353 10.92 7.44414 11.0283C7.51475 11.1366 7.61533 11.2221 7.73363 11.2742L13.4536 13.8809C13.6273 13.9601 13.816 14.0011 14.007 14.0011C14.1979 14.0011 14.3866 13.9601 14.5603 13.8809L20.2803 11.2809C20.3986 11.2287 20.4992 11.1433 20.5698 11.035C20.6404 10.9267 20.678 10.8002 20.678 10.6709C20.678 10.5416 20.6404 10.4151 20.5698 10.3068C20.4992 10.1985 20.3986 10.1131 20.2803 10.0609L14.5536 7.45422Z"
          stroke="#6570FC"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33203 14C7.33172 14.1275 7.36798 14.2524 7.43651 14.36C7.50505 14.4675 7.60298 14.5531 7.7187 14.6067L13.452 17.2133C13.6248 17.2916 13.8123 17.3321 14.002 17.3321C14.1917 17.3321 14.3792 17.2916 14.552 17.2133L20.272 14.6133C20.39 14.5603 20.4901 14.4741 20.5599 14.3652C20.6297 14.2562 20.6664 14.1294 20.6654 14"
          stroke="#6570FC"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33203 17.334C7.33172 17.4615 7.36798 17.5864 7.43651 17.694C7.50505 17.8015 7.60298 17.8871 7.7187 17.9407L13.452 20.5473C13.6248 20.6256 13.8123 20.666 14.002 20.666C14.1917 20.666 14.3792 20.6256 14.552 20.5473L20.272 17.9473C20.39 17.8943 20.4901 17.808 20.5599 17.6991C20.6297 17.5902 20.6664 17.4634 20.6654 17.334"
          stroke="#6570FC"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1240_6896">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IndustrySVG;
